import { PdCodeSnippet } from "./PdCodeSnippet.js";
//#region src/pd-code-snippet/pd-code-snippet.ts
customElements.define("pd-code-snippet", PdCodeSnippet);
//#endregion
export { PdCodeSnippet };
